module Sm.UI.Components.TimerView

open Fable.React
open Fable.React.Props
open MobF.React

open Sm.Core.Date

open Sm.UI.Form
open Sm.UI.Heatmap
open Sm.UI.Timer

open Sm.UI.Components.Control

[<ObserverComponent>]
let HeatmapChart (props: {| Heatmap: Heatmap; ShowLabel: bool |}) =
    let heatmap = props.Heatmap

    let classList = renderClassList [
        Append "heatmap"
        Toggle ("is-highlighted", heatmap.Highlight)
    ]

    div [Class classList] [
        if props.ShowLabel then
            yield label [] [str heatmap.Label]

        for r in 0..(heatmap.Rows - 1) do
            for c in 0..(heatmap.Columns - 1) ->
                let index = (r * heatmap.Columns) + c
                let sample = heatmap.Samples |> Map.tryFind index

                let classList = renderClassList [
                    Append "cell"

                    match sample with
                    | None -> ()
                    | Some sample ->
                        if sample.InActiveRange then Append "is-active"
                        if sample.IsNow then Append "is-now"
                        if sample.Value <> Value.Zero then Append "is-sampled"
                ]

                let palette = [|
                    127, 186, 254
                    136, 185, 255
                    145, 183, 255
                    155, 182, 255
                    165, 180, 255
                    176, 178, 255
                    186, 176, 255
                    196, 174, 255
                    207, 172, 255
                    217, 169, 255
                |]

                let tone bias =
                    match bias with
                    | 0.0 -> 0
                    | 1.0 -> 9
                    | x -> x * 10. |> floor |> int

                let color bias intensity =
                    let r, g, b = palette[tone bias]
                    sprintf "rgba(%i, %i, %i, %f)" r g b intensity

                let style = Style [
                    match sample with
                    | Some { Value = v } when v <> Value.Zero -> 
                        let c = color v.Bias v.Intensity
                        Custom ("--sample-color", c)
                        Custom ("--sample-intensity", string v.Intensity)
                    | _ -> ()
                ]

                div [Class classList; style] []
    ]

[<ObserverComponent>]
let TimerView (props: {| Timer: TimerModel |}) =
    let timer = props.Timer

    let classList = renderClassList [
        Append "timer"
        
        match timer.Computed.Mode with
        | Idle -> Append "is-inactive"
        | Programmed -> Append "is-pending"
        | Running -> Append "is-running"
        | Paused -> Append "is-paused"

        match timer.Computed.Time with
        | Some (Over _) -> Append "is-over"
        | _ -> ()
    ]

    div [Class "timer-view"] [
        div [Class classList] [
            span [Class "static left"] [str "session"]
            span [Class "static right"] [str "step"]

            span [Class "runner"] [
                iconFor Run []
            ]
            label [Class "time"] [
                match timer.Computed.Time with
                | Some (Under t) -> str (t.ClockFormat())
                | Some (Over t) -> strf "+%s" (t.ClockFormat())
                | None -> str "00:00"
            ]
            timer.Post |> renderButton timer.Computed.LeftButton
            timer.Post |> renderButton timer.Computed.RightButton
        ]
        div [Class "tracking-charts"] [
            for heatmap in timer.Computed.TrackingCharts -> 
                HeatmapChart {| Heatmap = heatmap; ShowLabel = true |}
        ]
    ]
